module.exports = __webpack_public_path__ + "e9e4e98948cefdb9531a3dd7e5cb481b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_13-mobile.png
// module id = 118
// module chunks = 1